"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calc = void 0;
var precision_1 = require("./precision");
exports.calc = {
    /**
     * 简单的加减乘除
     * @param sign 加减乘除标识
     * @param num 数字
     */
    numCalc: function (sign) {
        var num = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            num[_i - 1] = arguments[_i];
        }
        var result = num[0];
        for (var i = 1; i < num.length; i++) {
            result = this.simpleCalc(result, num[i], sign);
        }
        return result;
    },
    /**
     * 简单的加减乘除
     * @param num1 第一个计算公式
     * @param num2 第二个计算公式
     * @param sign 加减乘除标识
     * @param saveDecimal 保留几位小数
     */
    simpleCalc: function (num1, num2, sign, saveDecimal) {
        var _this = this;
        var calc = {
            '+': function () { return _this.add(num1, num2); },
            '-': function () { return _this.subtract(num1, num2); },
            '*': function () { return _this.multiply(num1, num2); },
            '/': function () { return _this.divide(num1, num2); }
        };
        var newSign = (sign && sign.replace(/\s+/g, '')) || '';
        if (calc[newSign]) {
            var result = calc[sign]();
            if (saveDecimal && typeof saveDecimal === 'number') {
                result = Number(result.toFixed(saveDecimal));
            }
            return result;
        }
        return 0;
    },
    // 将数值移除小数点取整并获取数值扩大的倍数
    getInteger: function (num1, num2) {
        // 小数点位数,移除小数点后的整数
        var point1 = 0;
        var point2 = 0;
        var integer1 = 0;
        var integer2 = 0;
        // 第一个数有小数点的处理
        if (num1 && num1.toString().split('.')[1]) {
            point1 = num1.toString().split('.')[1].length;
            integer1 = Number(num1.toString().replace('.', ''));
        }
        else
            integer1 = num1 || 0;
        // 第二个数有小数点的处理
        if (num2 && num2.toString().split('.')[1]) {
            point2 = num2.toString().split('.')[1].length;
            integer2 = Number(num2.toString().replace('.', ''));
        }
        else
            integer2 = num2 || 0;
        return {
            point1: point1,
            point2: point2,
            integer1: integer1,
            integer2: integer2
        };
    },
    // 计算需要乘除的扩大、缩小的数值
    pointNum: function (calc) {
        return Math.pow(10, calc);
    },
    // 加法计算
    add: function (num1, num2) {
        var _a = this.getInteger(num1, num2), point1 = _a.point1, point2 = _a.point2, integer1 = _a.integer1, integer2 = _a.integer2;
        return (integer1 * this.pointNum(point2) + integer2 * this.pointNum(point1)) / this.pointNum(point1 + point2);
    },
    // 减法计算
    subtract: function (num1, num2) {
        var _a = this.getInteger(num1, num2), point1 = _a.point1, point2 = _a.point2, integer1 = _a.integer1, integer2 = _a.integer2;
        return (integer1 * this.pointNum(point2) - integer2 * this.pointNum(point1)) / this.pointNum(point1 + point2);
    },
    // 乘法计算
    multiply: function (num1, num2) {
        var _a = this.getInteger(num1, num2), point1 = _a.point1, point2 = _a.point2, integer1 = _a.integer1, integer2 = _a.integer2;
        var mult = this.pointNum(point1 + point2);
        return (integer1 * integer2) / mult;
    },
    // 除法计算（小数点做乘法会有精度问题）
    divide: function (num1, num2) {
        var _a = this.getInteger(num1, num2), point1 = _a.point1, point2 = _a.point2, integer1 = _a.integer1, integer2 = _a.integer2;
        var div = this.pointNum(point2 - point1);
        return this.multiply(integer1 / integer2, div);
    },
    // 保留几位小数，并且会四舍五入,
    // 原生toFixed会存在四舍五入不准确的情况1.335.toFixed(2)=1.33, 1.375.toFixed(2)=1.38
    toFixed: function (num, saveDecimal) {
        var point = this.pointNum(saveDecimal);
        return this.divide(Math.round(this.multiply(num, point)), point);
    }
};
exports.default = {
    name: 'utils-calculate',
    install: function (UIP) {
        UIP.checkModule('utils', 'calculate');
        UIP.checkModule('utils', 'precision');
        UIP.utils.calculate = exports.calc;
        UIP.utils.precision = precision_1.default;
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/utils-calculate/dist/index.js
// module id = LNyt
// module chunks = 1